import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { getConfig } from '../config.service';
import { FunctionalAreaDetail, Building, StaticPoi, FmsIdParseResult } from './fms.models';

@Injectable({ providedIn: 'root' })
export class FmsService {
	private http = inject(HttpClient);

	async getFunctionalAreaDetail(siteId: number, faId: number): Promise<FunctionalAreaDetail | null> {
		try {
			return await firstValueFrom(
				this.http.get<FunctionalAreaDetail>(
					`${getConfig().api.middlewareUrl}/api/fms/functionalAreaDetail/${siteId}/${faId}`
				)
			);
		} catch (error) {
			console.error('[FmsService] Failed to get functional area detail:', error);
			return null;
		}
	}

	async getBuilding(siteId: number, buildingId: number): Promise<Building | null> {
		try {
			return await firstValueFrom(
				this.http.get<Building>(
					`${getConfig().api.middlewareUrl}/api/fms/building/${siteId}/${buildingId}`
				)
			);
		} catch (error) {
			console.error('[FmsService] Failed to get building:', error);
			return null;
		}
	}

	async getStaticPoiByPoiId(siteId: number, poiId: number): Promise<StaticPoi | null> {
		try {
			return await firstValueFrom(
				this.http.get<StaticPoi>(
					`${getConfig().api.middlewareUrl}/api/fms/staticpoibypoiid/${siteId}/${poiId}`
				)
			);
		} catch (error) {
			console.error('[FmsService] Failed to get static POI:', error);
			return null;
		}
	}

	/**
	 * Parses FMS ID from POI description.
	 * The description format is: "skomap:building:123" or "skomap:fa:37532"
	 */
	parseFmsIdFromDescription(description: string | undefined): FmsIdParseResult | null {
		if (!description) return null;

		const match = description.match(/skomap:(building|fa):(\d+)/);
		if (match) {
			return {
				type: match[1] as 'building' | 'fa',
				id: parseInt(match[2], 10)
			};
		}
		return null;
	}
}
